import { Injectable, Inject } from '@angular/core';
import { ICacheService } from './contracts/i-cache.service';
import { IEntityCacheService } from './contracts/i-entity-cache.service';
import { EntityCacheService } from './entity-cache.service';
import { ICacheOptions } from './models/cache.models';
import { NgCacheInfoAccessor } from './models/ng-cache-info.accessor';
import { NgCacheService } from './ng-cache.service';

@Injectable({ providedIn: 'root' })
export class CacheService {
  private readonly defaultCacheInfoAccessor: NgCacheInfoAccessor<any>;
  private readonly entityCaches: { [entityName: string]: IEntityCacheService<any> };

  public constructor(@Inject(NgCacheService) private readonly ngCacheService: ICacheService) {
    this.defaultCacheInfoAccessor = new NgCacheInfoAccessor<any>(ngCacheService);
    this.entityCaches = {};
  }

  public for<TEntity>(entityName: string, options: ICacheOptions): IEntityCacheService<TEntity> {
    let existingCache = this.entityCaches[entityName] as IEntityCacheService<TEntity>;
    if (existingCache) {
      if (!existingCache.areOptionsSame(options)) {
        throw new Error(`The options for entity cache ${entityName} were changed`);
      }
    } else {
      existingCache = this.entityCaches[entityName] = new EntityCacheService<TEntity>(this.defaultCacheInfoAccessor, entityName, options);
    }

    return existingCache;
  }

  public removeAll(): void {
    this.ngCacheService.removeAll();
  }

  public persist(): void {
    this.ngCacheService.persist();
  }

  public unPersist(): void {
    this.ngCacheService.unPersist();
  }
}
